import {useEffect} from 'react';
import {
  GrowthBook,
  GrowthBookProvider,
  useFeatureIsOn,
  useFeatureValue,
  FeaturesReady
} from '@growthbook/growthbook-react';
import {trackHeapEvent} from 'utils/analytics';
import {getClientVisitorUID} from 'utils/storage';

const trackMethod = (experiment, result) => {
  const variant = result?.key === '0' ? 'Control' : `Variation ${result?.key}`;
  trackHeapEvent(experiment.key, {
    Variant: variant
  });
};

export const initializeFlagService = () =>
  new GrowthBook({
    apiHost: process.env.NEXT_PUBLIC_GROWTHBOOK_API_HOST,
    clientKey: process.env.NEXT_PUBLIC_GROWTHBOOK_CLIENT_KEY,
    enableDevMode: !process.env.IS_PROD,
    subscribeToChanges: true,
    trackingCallback: trackMethod
  });

export const FLAG = {
  FREE_TRIAL_VARIANT: 'free_trial_variant',
  PRICING_STARTING_PRICE: 'pricing_starting_price',
  NEW_FTE_PRICING: 'new_fte_pricing'
};

export const isFlagEnabled = useFeatureIsOn;

export const getFeatureValue = useFeatureValue;

export const FlagServiceProvider = ({children, flagServiceInstance}) => {
  useEffect(() => {
    flagServiceInstance.setAttributes({
      client_visitor_uid: getClientVisitorUID()
    });
  }, []);

  return <GrowthBookProvider growthbook={flagServiceInstance}>{children}</GrowthBookProvider>;
};

export const FeaturesLoaded = FeaturesReady;
